import React, { useState, useEffect } from 'react';
import { useParams, Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';

function LeagueGamePage(activeLeague, setActiveLeague, activeSeason, setActiveSeason) {
  // const { seasonId } = useParams(); // Get leagueId from the URL
  const [searchParams] = useSearchParams(); // Get query parameters
  const [games, setGames] = useState([]);
  const seasonId = activeSeason.id;
  const leagueId = activeLeague.id;
  // Get the is_played value from query params or default to false
  const isPlayed = searchParams.get('is_played') === 'true';

  useEffect(() => {
    // Fetch games for the league
    axios
      .get(`/api/games/leagues/${leagueId}/`, {
        params: {
          season_id: seasonId,
          is_played: false
        },
        withCredentials: true,
      })
      .then((response) => setGames(response.data))
      .catch((error) => {
        console.error('Error fetching games:', error);
        alert('Unable to fetch games.');
      });
  }, [seasonId]);

  return (
    <div className="container">
      <div className="card p-4">
        <div className="card-header d-sm-flex align-items-center text-center justify-content-sm-between border-0 pb-0">
          <h2 className="h4 card-title">Games for Kickball</h2>
          <button className="btn btn-primary-soft" data-bs-toggle="modal" data-bs-target="#modalCreateEvents">
            <i className="fa-solid fa-plus pe-1"></i> Add Game
          </button>
        </div>
        <div className="card-body">
          <div className="row g-4">
            {games.map((game) => {
              const homeParticipant =
                game.teams?.find((p) => p.is_home) || {};
              const awayParticipant =
                game.teams?.find((p) => p.is_away) || {};
              const isByeGame = game.game_type === 'bye';

              return (
                <div key={game.id} className="col-sm-6 col-xl-4">
                  {/* Make the entire card clickable */}
                  <Link to={`/games/${game.id}`} className="text-decoration-none">
                    <div className="card h-100">
                      <div className="position-relative">
                        <div
                          style={{
                            width: '200px',
                            height: '200px',
                            margin: 'auto',
                            display: 'block',
                            position: 'relative',
                            overflow: 'hidden',
                            borderRadius: '8px',
                          }}
                        >
                          {homeParticipant.participant_logo ? (
                            // Top half - Home Team logo
                            <img
                              src={homeParticipant.participant_logo}
                              alt={`${homeParticipant.participant_name} logo`}
                              style={{
                                width: '200px',
                                height: '200px',
                                objectFit: 'cover',
                                position: 'absolute',
                                left: 0, // Ensure image is aligned to the left
                                top: 0,
                                clipPath: 'polygon(0 0, 100% 0, 100% 50%, 0 50%)',
                              }}
                            />
                          ) : (
                            // Placeholder for top half - Blue
                            <div
                              style={{
                                width: '100%',
                                height: '50%',
                                backgroundColor: 'blue',
                                position: 'absolute',
                                top: 0,
                              }}
                            ></div>
                          )}

                          {awayParticipant.participant_logo ? (
                            // Bottom half - Away Team logo
                            <img
                              src={awayParticipant.participant_logo}
                              alt={`${awayParticipant.participant_name} logo`}
                              style={{
                                width: '200px',
                                height: '200px',
                                objectFit: 'cover',
                                position: 'absolute',
                                left: 0, // Ensure image is aligned to the left
                                bottom: 0,
                                clipPath: 'polygon(0 50%, 100% 50%, 100% 100%, 0 100%)',
                              }}
                            />
                          ) : (
                            // Placeholder for bottom half - Red
                            <div
                              style={{
                                width: '100%',
                                height: '50%',
                                backgroundColor: 'red',
                                position: 'absolute',
                                bottom: 0,
                              }}
                            ></div>
                          )}
                        </div>
                      </div>
                      <div className="card-body position-relative pt-0">
                        <div className="row">
                          <h6 className="mt-3 text-dark">
                            {homeParticipant.participant_name || 'Home Team'}
                          </h6>
                          <h6 className="mt-3 text-dark">
                            vs.{' '}
                          </h6>
                          <h6 className="mt-3 text-dark">
                            {awayParticipant.participant_name || 'Away Team'}
                          </h6>
                        </div>
                        <p className="mb-0 small text-muted">
                          <i className="bi bi-calendar-check pe-1"></i> Date: {game.scheduled_date_only}
                        </p>
                        <p className="small text-muted">
                          <i className="bi bi-clock pe-1"></i> Time: {game.scheduled_time_only}
                        </p>
                        <p className="small text-muted">
                          <i className="bi bi-geo-alt pe-1"></i> Location: {game.location}
                        </p>
                      </div>
                    </div>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LeagueGamePage;
